import { ColoredTextFindReplaceItem, ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { ColumnCleanerRule } from 'src/app/domainObjects/transformers/columnCleanerTransform';
import { RuleType } from './columnCleanerViewModel';
import { Separator, SeparatorNone } from 'src/app/domainObjects/separator';

export class ColumnCleanerRuleViewModel extends TransformRuleViewModel {
    ruleTypeIndex:number;
    ruleType : RuleType;
    fields: ColoredTextItem[];
    conditionalFields: ColoredTextItem[];
    splitField: string;
    criteria: Criteria;
    matchValue: ColoredTextItem[];
    matchValueList?: ColoredTextFindReplaceItem[];
    ifMatched: boolean;
    andOr: AndOr;
    findReplace: ColoredTextFindReplaceItem[];
    matchAll: boolean;
    deleteWhenEmpty: number;
    separator: SeparatorNone;
    matchCase: boolean;
    targetField: string;
    emptyFieldValue: string;
    removeChars: string;
    keepOrigColumn: boolean;
    maxColumns: number; 
    colBaseName: string;
    noChars: number;
    startPos: number; 
    formatAs:FormatAs;
    duplicatesType: DuplicateType;
    duplicatesKeep: DuplicateKeep;
    moveColumns:ColoredTextFindReplaceItem[];
    overWriteData: boolean;
    articleOption: Prepositions;
    conjunctionOption: Prepositions;
    determinerOption: Prepositions;
    prepOption: Prepositions;
    removeOption:RemoveOption;

    rowsDeleted?: number;
    rowsRemaining?: number;
    valuesModified?: number;
    groupHits?: number;

    rowHits?: number;
    sampleRowHits?: number;

    constructor(rule: ColumnCleanerRule,private matchValueEntryService: MatchValueEntryService) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);

      this.ruleTypeIndex = rule.ruleTypeIndex;
      this.ruleType = rule.ruleType;
      let colorIndex = 0;
      this.fields = rule.fields?.map(r => {
          const color = NamedColorList[colorIndex % NamedColorList.length];
          colorIndex++;
          return new ColoredTextItem(r, color);
      }) ?? [];
      //(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      colorIndex = 0;
      this.conditionalFields = rule.conditionalFields?.map(r => {
          const color = NamedColorList[colorIndex % NamedColorList.length];
          colorIndex++;
          return new ColoredTextItem(r, color);
      }) ?? [];
      //(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      if(rule.ruleType==RuleType.splitColumns || rule.ruleType==RuleType.splitintowords || rule.ruleType==RuleType.removeChars){
        if(rule.fields){
          this.splitField = rule.fields.length > 0 ? rule.fields[0] : '';
        }
      }
      this.criteria = rule.criteria;
      //this.preCriteria = rule.criteria;

      //this.matchValue = rule.matchValue?.map(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      colorIndex = 0;
      if(this.matchValueEntryService.MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeSingle || this.matchValueEntryService.MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeMulti){
        this.matchValueList = rule.matchValue?.map(([find, replace], index) => new ColoredTextFindReplaceItem(find, replace, NamedColorList[colorIndex++])) ?? [];
      }else{
        this.matchValue = rule.matchValue?.map(([text], index) => new ColoredTextItem(text, NamedColorList[colorIndex++])) ?? [];
      }

      this.ifMatched = rule.ifMatched;
      this.andOr = rule.andOr;
      //this.keepRow = rule.keepRow;
      colorIndex = 0;
      this.findReplace = rule.findReplace 
              ? Object.entries(rule.findReplace).map(([find, replace], index) => {
                  // Reset or cycle through the NamedColorList array with colorIndex modulo NamedColorList length
                  const color = NamedColorList[index % NamedColorList.length];
                  return new ColoredTextFindReplaceItem(find, replace, color);
                })
              : [];
      this.matchAll = rule.matchAll;
      this.deleteWhenEmpty = rule.deleteWhenEmpty;
      this.separator = rule.separator;
      this.matchCase = rule.matchCase;
      this.targetField = rule.targetField;
      this.emptyFieldValue = rule.emptyFieldValue;
      this.removeChars = rule.removeChars;
      this.keepOrigColumn = rule.keepOrigColumn;
      this.maxColumns = rule.maxColumns; 
      this.colBaseName = rule.colBaseName;
      this.noChars = rule.noChars;
      this.startPos = rule.startPos;
      this.formatAs = rule.formatAs;
      this.duplicatesType = rule.duplicatesType;
      this.duplicatesKeep = rule.duplicatesKeep;
      colorIndex = 0;
      this.moveColumns = rule.moveColumns 
              ? Object.entries(rule.moveColumns).map(([find, replace], index) => {
                  // Reset or cycle through the NamedColorList array with colorIndex modulo NamedColorList length
                  const color = NamedColorList[index % NamedColorList.length];
                  return new ColoredTextFindReplaceItem(replace,find, color);
                })
              : [];
      this.overWriteData = rule.overWriteData;
      this.articleOption = rule.articleOption;
      this.conjunctionOption = rule.conjunctionOption;
      this.determinerOption = rule.determinerOption;
      this.prepOption = rule.prepOption;
      this.removeOption = rule.removeOption;
    }

    toRule(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      //rule.ruleId = this.id;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.criteria = this.criteria;
      if(this.matchValue.length==0){
        rule.matchValue=undefined;
      }else{
       // rule.matchValue = this.matchValue?.map(i => i.text);
      }
      rule.ifMatched = this.ifMatched;
      rule.andOr = this.andOr;
      //rule.keepRow = this.keepRow;
      if(this.findReplace.length===0){
        rule.findReplace=undefined;
      }else{
        rule.findReplace={};
        this.findReplace.forEach(item => {
          rule.findReplace[item.find] = item.replace;
        });
      }
      rule.matchAll = this.matchAll;
      rule.deleteWhenEmpty = this.deleteWhenEmpty;
      rule.separator = this.separator;
      rule.matchCase = this.matchCase;
      rule.targetField = this.targetField;
      rule.emptyFieldValue = this.emptyFieldValue;
      rule.removeChars = this.removeChars;
      rule.keepOrigColumn = this.keepOrigColumn;
      rule.maxColumns = this.maxColumns; 
      rule.colBaseName = this.colBaseName;
      rule.noChars = this.noChars;
      rule.startPos = this.startPos;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleDeleteRows(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.criteria = this.criteria;
      if(this.matchValueEntryService.MatchValueEntryEditor(this.criteria,this.andOr)==MatchValueEntryType.rangeSingle || this.matchValueEntryService.MatchValueEntryEditor(this.criteria,this.andOr)==MatchValueEntryType.rangeMulti){
        rule.matchValue = this.matchValueList.map(item => [item.find.toString(), item.replace.toString()]);
      }else{
        rule.matchValue = this.matchValue.map(item => [item.text.toString()]);
      }
      if(rule.matchValue.length==0){
        rule.matchValue=undefined;//[];//undefined; to avoid error for now []
      }
      rule.ifMatched = this.ifMatched;
      rule.andOr = this.andOr;
      rule.matchCase = this.matchCase;

      rule.conditionalFields = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleDeDuplicate(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.duplicatesType = this.duplicatesType;
      rule.duplicatesKeep = this.duplicatesKeep;
      rule.matchCase = this.matchCase;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleFindReplace(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      if(this.findReplace.length===0){
        rule.findReplace=undefined;
      }else{
        rule.findReplace={};
        this.findReplace.forEach(item => {
          rule.findReplace[item.find] = item.replace;
        });
      }
      rule.matchAll = this.matchAll;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      rule.matchCase = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleFindReplaceAdv(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.conditionalFields = this.conditionalFields?.map(i => i.text);
      if(this.findReplace.length===0){
        rule.findReplace=undefined;
      }else{
        rule.findReplace={};
        this.findReplace.forEach(item => {
          rule.findReplace[item.find] = item.replace;
        });
      }
      rule.matchAll = this.matchAll;
      rule.andOr = this.andOr;
      rule.matchCase = this.matchCase;
      rule.criteria = this.criteria;
      if(this.matchValueEntryService.MatchValueEntryEditor(this.criteria,this.andOr)==MatchValueEntryType.rangeSingle || this.matchValueEntryService.MatchValueEntryEditor(this.criteria,this.andOr)==MatchValueEntryType.rangeMulti){
        rule.matchValue = this.matchValueList.map(item => [item.find.toString(), item.replace.toString()]);
      }else{
        rule.matchValue = this.matchValue.map(item => [item.text.toString()]);
      }
      if(rule.matchValue.length==0){
        rule.matchValue=undefined;//[];//undefined; to avoid error for now []
      }
      
      rule.ifMatched = undefined;
      //rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      //rule.matchCase = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleDeleteColumns(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.deleteWhenEmpty = this.deleteWhenEmpty;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.separator = undefined;
      rule.matchCase = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleCombineColumns(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.separator = this.separator;
      rule.targetField = this.targetField;
      rule.emptyFieldValue = this.emptyFieldValue;
      rule.keepOrigColumn = this.keepOrigColumn;
      rule.removeChars = this.removeChars;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.matchCase = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleSplitColumns(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields =[this.splitField];
      rule.separator = this.separator;
      rule.maxColumns = this.maxColumns; 
      rule.removeChars = this.removeChars;
      rule.keepOrigColumn = this.keepOrigColumn;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.matchCase = undefined;
      rule.emptyFieldValue = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleFormatColumns(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields = this.fields?.map(i => i.text);
      rule.formatAs = this.formatAs;
      rule.removeChars = this.removeChars;
      rule.noChars = this.noChars;
      rule.startPos = this.startPos;

      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      rule.matchCase = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.keepOrigColumn = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleMoveColumns(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      if(this.moveColumns.length===0){
        rule.moveColumns=undefined;
      }else{
        rule.moveColumns={};
        this.moveColumns.forEach(item => {
          rule.moveColumns[item.replace] = item.find;
        });
      }
      rule.overWriteData = this.overWriteData;
      rule.keepOrigColumn = this.keepOrigColumn;
      
      rule.matchAll = undefined;
      rule.fields = undefined;
      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.separator = undefined;
      rule.matchCase = undefined;
      rule.targetField = undefined;
      rule.emptyFieldValue = undefined;
      rule.removeChars = undefined;
      rule.maxColumns = undefined; 
      rule.colBaseName = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleSplitIntoWords(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields =[this.splitField];
      rule.targetField = this.targetField;
      rule.articleOption = this.articleOption;
      rule.conjunctionOption = this.conjunctionOption;
      rule.determinerOption = this.determinerOption;
      rule.prepOption = this.prepOption;
      rule.keepOrigColumn = this.keepOrigColumn;

      rule.removeChars = undefined;
      rule.maxColumns = undefined;
      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.matchCase = undefined;
      rule.emptyFieldValue = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.removeOption = undefined;
      return rule;
    }
    toRuleRemoveCharacters(): ColumnCleanerRule {
      const rule = new ColumnCleanerRule();
      rule.ruleTypeIndex = this.ruleTypeIndex;
      rule.ruleType = this.ruleType;
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.run = this.run;
      rule.fields =[this.splitField];
      rule.targetField = this.targetField;
      rule.removeChars = this.removeChars;
      rule.removeOption = this.removeOption;
      rule.keepOrigColumn = this.keepOrigColumn;

      rule.maxColumns = undefined;
      rule.conditionalFields = undefined;
      rule.criteria = undefined;
      rule.matchValue = undefined;
      rule.ifMatched = undefined;
      rule.andOr = undefined;
      //rule.keepRow = undefined;
      rule.findReplace=undefined;
      rule.matchAll = undefined;
      rule.deleteWhenEmpty = undefined;
      rule.matchCase = undefined;
      rule.emptyFieldValue = undefined;
      rule.noChars = undefined;
      rule.startPos = undefined;
      rule.articleOption = undefined;
      rule.conjunctionOption = undefined;
      rule.determinerOption = undefined;
      rule.prepOption = undefined;
      return rule;
    }
}
export enum Criteria{
  empty = 0,
  matches = 1,
  contains = 2,
  startsWith = 3,
  endsWith = 4,
  boolTrue = 5,
  boolFalse = 6,
  equals = 7,
  //lessOrGreaterThan = 8,
  lessThan = 8,
  greaterThan = 9,
  LessThanOrEqualTo = 10,
  greaterThanOrEqualTo = 11,
  between = 12,
  inclusiveLeft = 13,
  inclusiveRight = 14,
  inclusiveBoth = 15,
  equalToday = 16,
  lastnDays = 17,
  length = 18,
  none = 19,
  notContains = 20,
  columnMatch = 21
}
export class CriteriaUtil {
  static toString(criteria: Criteria): string {
      switch (criteria) {
        case Criteria.empty: return 'Empty';
        case Criteria.matches: return 'Matches';
        case Criteria.contains: return 'Contains';
        case Criteria.startsWith: return 'Starts With';
        case Criteria.endsWith: return 'Ends With';
        case Criteria.boolTrue: return 'Bool True';
        case Criteria.boolFalse: return 'Bool False';
        case Criteria.equals: return 'Equals';
        //case Criteria.lessOrGreaterThan: return 'lessOrGreaterThan';
        case Criteria.lessThan: return 'Less than';
        case Criteria.greaterThan: return 'Greater than';
        case Criteria.LessThanOrEqualTo: return 'Less than or Equal';
        case Criteria.greaterThanOrEqualTo: return 'Greater than or Equal';
        case Criteria.between: return 'Between';
        case Criteria.inclusiveLeft: return 'Inclusive Left';
        case Criteria.inclusiveRight: return 'Inclusive Right';
        case Criteria.inclusiveBoth: return 'Inclusive Both';
        case Criteria.equalToday: return 'Equal Today';
        case Criteria.lastnDays: return 'Last n Days';
        case Criteria.length: return 'Length';
        case Criteria.none: return 'None';
        case Criteria.notContains: return 'Not Contains';
        case Criteria.columnMatch: return 'Column Match';
      }
  }
}
export enum KeepRow{
  first = 0,
  last = 1,
  noRows = 2
}
export class KeepRowUtil {
  static toString(keeprow: KeepRow): string {
      switch (keeprow) {
        case KeepRow.first: return 'First Row';
        case KeepRow.last: return 'Last Row';
        case KeepRow.noRows: return 'No Rows';
      }
  }
}

export enum FormatAs{
  title = 0,
  upper = 1,
  lower = 2,
  leftChars = 3,
  rightChars = 4,
  midChars = 5
}
export class FormatAsUtil {
  static toString(removeChars: FormatAs): string {
      switch (removeChars) {
        case FormatAs.title: return 'Title Case';
        case FormatAs.upper: return 'UPPER CASE';
        case FormatAs.lower: return 'lower case';
        case FormatAs.leftChars: return 'Left Chars';
        case FormatAs.rightChars: return 'Right Chars';
        case FormatAs.midChars: return 'Mid Chars';
      }
  }
}
export class CriteriaUtilSymbol {
  static toString(criteria: Criteria): string {
      switch (criteria) {
        case Criteria.equals: return '=';
        case Criteria.lessThan: return '<';
        case Criteria.greaterThan: return '>';
        case Criteria.LessThanOrEqualTo: return '<=';
        case Criteria.greaterThanOrEqualTo: return '>=';
        case Criteria.between: return '=<>=';
        case Criteria.inclusiveLeft: return '=<>';
        case Criteria.inclusiveRight: return '<>=';
        case Criteria.inclusiveBoth: return '=<>=';
        case Criteria.length: return '<—>';
        case Criteria.lastnDays: return '';
      }
      return '';
  }
}

export enum AndOr{
  orOr = 0,
  andOr = 1,
  orAnd = 2,
  andAnd = 3,
  pairedOr = 4,
  pairedAnd = 5
  
}
export class AndOrUtil {
  static toString(andOr: AndOr): string {
      switch (andOr) {
        case AndOr.orOr: return 'OR | OR';
        case AndOr.andOr: return 'AND | OR';
        case AndOr.orAnd: return 'OR | AND';
        case AndOr.andAnd: return 'AND | AND';
        case AndOr.pairedOr: return 'Paired OR';
        case AndOr.pairedAnd: return 'Paired AND';
      }
  }
}

export enum AndOrGroup{
  nonPaired = 0,
  paired = 1
  
}
export enum MatchValueEntryType {
  disable = 1,
  multiSingle,
  multiMulti,
  valueSingle,
  valueMulti,
  rangeSingle,
  rangeMulti
}

export enum DuplicateType{
  exclude = 0,
  include = 1
}
export class DuplicateTypeUtil {
  static toString(duplicateType: DuplicateType): string {
      switch (duplicateType) {
        case DuplicateType.exclude: return 'Exclude';
        case DuplicateType.include: return 'Include';
      }
  }
}
export enum DuplicateKeep {
  first = 0,
  last = 1,
  noRows = 2
}
export class DuplicateKeepUtil {
  static toString(duplicateKeep: DuplicateKeep): string {
      switch (duplicateKeep) {
        case DuplicateKeep.first: return 'First';
        case DuplicateKeep.last: return 'Last';
        case DuplicateKeep.noRows: return 'No Rows';
      }
  }
}

export enum Prepositions{
  nochange = 0,
  remove = 1,
  lowercase = 2
}
export class PrepositionsUtil {
  static toString(preposition: Prepositions): string {
      switch (preposition) {
        case Prepositions.nochange: return 'No change';
        case Prepositions.remove: return 'Remove';
        case Prepositions.lowercase: return 'Lower case';
      }
  }
}
export enum RemoveOption{
  smartClean = 0,
  removeAll = 1,
  leadingTrailing = 2,
  pattern = 3
}
export class RemoveOptionUtil {
  static toString(removeoption: RemoveOption): string {
      switch (removeoption) {
        case RemoveOption.smartClean: return 'Smart clean';
        case RemoveOption.removeAll: return 'Remove all';
        case RemoveOption.leadingTrailing: return 'Leading/Trailing';
        case RemoveOption.pattern: return 'Pattern';
      }
  }
}
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root' // This makes it available throughout the app
})
export class MatchValueEntryService {

  MatchValueEntryEditor(criteria: Criteria,andOr:AndOr): MatchValueEntryType {
    if ([Criteria.empty,
        Criteria.boolTrue,
        Criteria.boolFalse,
        Criteria.equalToday,
        Criteria.none,
        Criteria.columnMatch].includes(criteria)) {
      return MatchValueEntryType.disable;
    } else if ([Criteria.matches,
                Criteria.contains,
                Criteria.startsWith,
                Criteria.endsWith,
                Criteria.notContains].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.nonPaired) {
      return MatchValueEntryType.multiSingle;
    }else if ([Criteria.matches,
                Criteria.contains,
                Criteria.startsWith,
                Criteria.endsWith,
                Criteria.notContains].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.paired) {
      return MatchValueEntryType.multiMulti;
    } else if ([Criteria.equals,
                Criteria.lessThan,
                Criteria.greaterThan,
                Criteria.LessThanOrEqualTo,
                Criteria.greaterThanOrEqualTo,
                Criteria.lastnDays].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.nonPaired) {
      return MatchValueEntryType.valueSingle;
    } else if ([Criteria.equals,
                Criteria.lessThan,
                Criteria.greaterThan,
                Criteria.LessThanOrEqualTo,
                Criteria.greaterThanOrEqualTo,
                Criteria.lastnDays].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.paired) {
      return MatchValueEntryType.valueMulti;
    } else if ([Criteria.between,
                Criteria.inclusiveLeft,
                Criteria.inclusiveRight,
                Criteria.inclusiveBoth,
                Criteria.length].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.nonPaired) {
      return MatchValueEntryType.rangeSingle;
    } else if ([Criteria.between,
                Criteria.inclusiveLeft,
                Criteria.inclusiveRight,
                Criteria.inclusiveBoth,
                Criteria.length].includes(criteria) && this.GetGroupAndOr(andOr)==AndOrGroup.paired) {
      return MatchValueEntryType.rangeMulti;
    } else {
      return MatchValueEntryType.disable;
    }
  }

  GetGroupAndOr(andOr:AndOr): AndOrGroup {
    if ([AndOr.orOr,
        AndOr.andOr,
        AndOr.orAnd,
        AndOr.andAnd].includes(andOr)) {
      return AndOrGroup.nonPaired;
    } else if ([AndOr.pairedOr,
              AndOr.pairedAnd].includes(andOr)) {
      return AndOrGroup.paired;
    }else{
      return AndOrGroup.nonPaired;
    }
  }
}
